import { TooltipProps } from '@chakra-ui/react';

export enum InteractionType {
  Expandable = 'expandable',
  Tooltip = 'tooltip',
}

interface BaseInteraction {
  type: InteractionType;
  data?: object;
}
export interface ExpandableInteraction extends BaseInteraction {
  type: InteractionType.Expandable;
}

interface TooltipInteractionData {
  content: string;
  elementProps?: Partial<TooltipProps>;
}
export interface TooltipInteraction extends BaseInteraction {
  type: InteractionType.Tooltip;
  data: TooltipInteractionData;
}
export type Interaction = BaseInteraction | ExpandableInteraction | TooltipInteraction;

// null means the interaction is disabled
export type InteractionsMap = { [key in InteractionType]?: Interaction | null };

export interface InteractiveElement {
  interactions?: InteractionsMap;
}
